// AFL => Application for leave

import { AFLType } from "../models";

export const aflTypeLabel: Record<AFLType, string> = {
  [AFLType.ApplicationForLeave]: "Đơn xin nghỉ phép",
  [AFLType.MaternityLeaveApplication]: "Đơn xin nghỉ hộ sản",
  [AFLType.SickLeaveApplication]: "Đơn xin nghỉ ốm/nuôi con ốm",
  [AFLType.AccidentLeaveApplication]: "Đơn xin nghỉ do TNRR/TNGT/ĐTBNN/BDN",
  [AFLType.AccidentNotification]: "Thông báo TNRR/TNGT",
  [AFLType.AFLNoSalary]: "Đơn xin nghỉ phép không lương",
  [AFLType.AFLSuspendContract]: "Đơn xin tạm hoãn hợp đồng lao động",
  [AFLType.TerminationContractApplication]: "Đơn xin chấm dứt hợp đồng",
};

export const aflTypeShortLabel: Record<AFLType, string> = {
  [AFLType.ApplicationForLeave]: "nghỉ phép",
  [AFLType.MaternityLeaveApplication]: "nghỉ thai sản",
  [AFLType.SickLeaveApplication]: "nghỉ ốm/nuôi con ốm",
  [AFLType.AccidentLeaveApplication]: "nghỉ do TNRR/TNGT/ĐTBNN/BDN",
  [AFLType.AccidentNotification]: "Thông báo TNRR/TNGT",
  [AFLType.AFLNoSalary]: "nghỉ không lương",
  [AFLType.AFLSuspendContract]: "tạm hoãn hợp đồng lao động",
  [AFLType.TerminationContractApplication]: "chấm dứt hợp đồng",
};

export const aflTypeOptions = Object.keys(aflTypeLabel).map((aflType) => ({
  label: aflTypeLabel[aflType as AFLType],
  value: `${aflType}|${aflTypeLabel[aflType as AFLType]}`,
}));

export const approveProcess = [
  { titleField: "eApprovedBy", statusField: "eApprovedStatus" },
  { titleField: "eApprovedByITLead", statusField: "eApprovedByITLeadStatus" },
  { titleField: "eApprovedByITHead", statusField: "eApprovedByITHeadStatus" },
  { titleField: "eAssignee", statusField: "eAssigneeStatus" },
];

export const withPositionTypes: string[] = [
  AFLType.AFLNoSalary,
  AFLType.ApplicationForLeave,
  AFLType.TerminationContractApplication,
];

export enum Overseas {
  Overseas = "Overseas",
  Internal = "Internal"
}
